export default {
    data: () => ({
        translations: {
            title: {
                el: "Push Notifications",
                en: "Push Notifications",
                it: "Push Notifications"
            },
            restApiKey: {
                el: "",
                en: "REST API Key",
                it: ""
            },
            oneSignalAppId: {
                el: "",
                en: "One Signal App ID",
                it: ""
            }
        }
    })
};
